import { formatDate, formatMoney } from './helpers';
import {
    paymentStatus,
    paymentType,
    paymentPayWay,
    paymentPayToType,
    serviceTypeList,
    abdType,
} from '../../assets/commonData/options';

// 請款狀態
function getPaymentStatus(data) {
    if (!data) return null;

    let statusName = paymentStatus.find((x) => x.key === data.sigN_STS)?.value;

    // 待審核、已暫存
    if (data.sigN_STS === 5 && data.a02_ISTEMP) {
        statusName = `${statusName}（暫存）`;
    }

    return statusName;
}

function getHierarchyItemNames(allOptions, itemSno) {
    const hierarchy = [null, null, null];

    const types = [
        { key: 'payoutSettings', name: '營業支出' },
        { key: 'invoiceSettings', name: '營業收入' },
        { key: 'cInSettings', name: '營業其他收入' },
        { key: 'cInElseSettings', name: '財務資產收入' },
        { key: 'cOutSettings', name: '營業其他支出' },
        { key: 'cOutElseSettings', name: '財務資產支出' },
    ];

    // eslint-disable-next-line no-restricted-syntax, guard-for-in
    for (const t in types) {
        const options = allOptions[types[t].key];
        // eslint-disable-next-line no-restricted-syntax, guard-for-in
        for (const i in options) {
            const lv1Item = options[i];
            // eslint-disable-next-line no-restricted-syntax, guard-for-in
            for (const j in lv1Item.childSettings) {
                const lv2Item = lv1Item.childSettings[j];
                if (lv2Item.sno === itemSno) {
                    hierarchy[0] = types[t].name;
                    hierarchy[1] = lv1Item.iteM_NAM;
                    hierarchy[2] = lv2Item.iteM_NAM;
                    break;
                }
            }
        }
    }

    return hierarchy.join(' / ');
}

// 支出項目
function getPayoutItemName(data, statementOptions) {
    return getHierarchyItemNames(statementOptions, data?.iteM_SNO);
}

// 請款類型
function getPaymentType(data) {
    return data ? paymentType.find((x) => x.key === data.typ)?.value : null;
}

// 經常性支出名稱
function getOftenProjectName(data) {
    return data?.ofeN_ITEM_NAM;
}

// 預計付款方式
function getPrePayWay(data) {
    if (!data) {
        return null;
    }

    let payWay = paymentPayWay.find((x) => x.key === data.useR_PAY_WAY)?.label;

    // 銀行轉帳且為境外銀行
    if (data.useR_PAY_WAY === 2 && data.abd === 1) {
        const adbTypeName = abdType.find((x) => x.key === data.abD_TYP)?.label;
        if (adbTypeName) {
            payWay = `${payWay} (境外-${adbTypeName})`;
        }
    }
    return payWay;
}

// 付款對象類型
function getPayToType(data) {
    return data ? paymentPayToType.find((x) => x.key === data.paY_TO)?.label : null;
}

// 付款對象名稱
function getPayToName(data) {
    if (!data) return null;

    // 公司員工
    if (data.paY_TO === 1) {
        return data?.payName;
    }
    // 委外廠商、委外個人勞務
    if (data.paY_TO === 2 || data.paY_TO === 3) {
        return data?.vdR_NAM;
    }
    return null;
}

// 勞務所得類別
function getServiceType(data) {
    return data ? serviceTypeList.find((x) => x.value === data.serviceType)?.label : null;
}

// 收款銀行
function getReceiveBankName(data) {
    if (data.useR_PAY_WAY === 1) return null; // 當預計付款方式為零用現金時，不顯示
    if (data.useR_PAY_WAY === 2 && data.abd === 1) {
        // 銀行轉帳-境外
        return data.abroadBankName;
    }
    return `${data.bankName} (${data.vdR_BNK_BOO})`;
}

// 收款戶名
function getReceiveBankAccount(data) {
    if (data.useR_PAY_WAY === 1) return null; // 當預計付款方式為零用現金時，不顯示
    return data?.vdR_BNK_TPC;
}

// 收款銀行代號
function getReceiveBankBranchCode(data) {
    if (data.useR_PAY_WAY === 1) return null; // 當預計付款方式為零用現金時，不顯示
    return data?.vdR_BNK_DOO;
}

// 收款銀行帳號
function getReceiveBankNumber(data) {
    if (data.useR_PAY_WAY === 1) return null; // 當預計付款方式為零用現金時，不顯示
    return data?.vdR_BNK_ACC;
}

// 實付金額（請款總額 - 各項代扣）
function getRealPayAmt(data) {
    return data ? formatMoney(data.amt - data.taX_AMT - data.geN2_AMT) : null;
}

// 實付金額約當台幣（請款總額 - 各項代扣）* 當下匯率
function getRealPayAmtTwd(data) {
    return data ? formatMoney(Math.round((data.amt - data.taX_AMT - data.geN2_AMT) * data.paY_CNYRAT)) : null;
}

// 實際付款方式
function getRealPayWay(data) {
    return data ? paymentPayWay.find((x) => x.key === data.paY_WAY)?.label : null;
}

// 填寫付款明細人
function getFillPayInfoUser(data) {
    if (!data) return null;

    // 請款狀態：待確認付款 ＆ 完成才顯示
    if (data.sigN_STS === 2 || data.sigN_STS === 3) {
        return data.audits.find((x) => x.menU_UNT === 'A02')?.stF_NAM;
    }
    return null;
}

// 填寫付款明細日期
function getFillPayInfoDate(data) {
    if (!data) return null;

    // 請款狀態：待確認付款 ＆ 完成才顯示
    if (data.sigN_STS === 2 || data.sigN_STS === 3) {
        return formatDate(data.audits.find((x) => x.menU_UNT === 'A02')?.sdat);
    }
    return null;
}

// 確認付款明細人
function getConfirmPayInfoUser(data) {
    if (!data) return null;

    // 請款狀態：完成才顯示
    if (data.sigN_STS === 3) {
        return data.audits.find((x) => x.menU_UNT === 'A03')?.stF_NAM;
    }
    return null;
}

// 確認付款明細日期
function getConfirmPayInfoDate(data) {
    if (!data) return null;

    // 請款狀態：完成才顯示
    if (data.sigN_STS === 3) {
        return formatDate(data.audits.find((x) => x.menU_UNT === 'A03')?.sdat);
    }
    return null;
}

// 審核流程
function getAuditCurrStepIndex(data) {
    if (data.status === 4) {
        return -1;
    }
    if (data.audits) {
        for (let i = 0; i < data.audits.length; i += 1) {
            if (data.audits[i].fin === 0) {
                return i;
            }
        }
    }
    return 0;
}

function getAuditActionName(menUnt) {
    if (menUnt === 'A02') return '付款';
    if (menUnt === 'A03') return '完成';
    if (menUnt === '主管') return '主管審核';
    if (menUnt === '專案PM') return '專案經理';
    return menUnt;
}

function getAuditProgressItems(detail) {
    const items = [];
    detail.audits.forEach((a) => {
        items.push({
            title: getAuditActionName(a.menU_UNT),
            staff: a.stF_NAM,
            dat: a.sdat ? formatDate(a.sdat) : null,
            auditors: a.auditors,
            fin: a.fin,
        });
    });

    // 財務單沒有審核流程，手動增加完成
    if (detail.audits.length === 0) {
        items.push({
            title: '完成',
            staff: ' ',
            dat: ' ',
            auditors: null,
            fin: 1,
        });
    }

    // 後端資料都沒有申請，手動加上
    items.unshift({
        title: '申請',
        staff: detail.creator,
        dat: formatDate(detail.crT_DAT),
    });
    return items;
}

function getAuditsData(data) {
    return {
        currIndex: getAuditCurrStepIndex(data),
        items: getAuditProgressItems(data),
    };
}

export default (data, statementOptions, companyName = '---') => {
    const d = {
        raw: data, // 原始資料
        companyName, // 公司名稱
        payoo: data?.payoo || '---', // 請款單號
        status: getPaymentStatus(data) || '---', // 請款狀態
        date: formatDate(data?.dat) || '---', // 請款單日期
        creator: data?.creator || '---', // 申請人
        createDate: formatDate(data?.crT_DAT) || '---', // 申請日期
        type: getPaymentType(data) || '---', // 請款類型
        name: data?.nam || '---', // 摘要
        payoutItemName: getPayoutItemName(data, statementOptions) || '---', // 支出項目
        projectName: data?.projectName || '---', // 專案名稱
        oftenProjectName: getOftenProjectName(data) || '---', // 經常性支出名稱
        prePayWay: getPrePayWay(data) || '---', // 預計付款方式
        prePayDate: formatDate(data?.pdat) || '---', // 預計付款日
        amt: formatMoney(data?.amt) || '---', // 請款金額
        cny: data?.cny || '---', // 請款幣別
        payToType: getPayToType(data) || '---', // 付款對象類型
        payToName: getPayToName(data) || '---', // 付款對象名稱
        serviceType: getServiceType(data) || '---', // 勞務所得類別
        serviceInfo: data?.oS_MEM || '---', // 工作內容
        receiveBankAccount: getReceiveBankAccount(data) || '---', // 收款戶名
        receiveBankName: getReceiveBankName(data) || '---', // 收款銀行-分行
        receiveBankBranchCode: getReceiveBankBranchCode(data) || '---', // 收款銀行代號
        receiveBankNumber: getReceiveBankNumber(data) || '---', // 收款帳號
        contactName: data?.vdR_NAM || '---', // 聯絡人
        contactTel: data?.vdR_TEL || '---', // 聯絡電話
        contactEmail: data?.vdR_EML || '---', // 聯絡電子信箱
        taxAmt: formatMoney(data?.taX_AMT) || '---', // 代扣勞務稅金額
        taxPayDate: formatDate(data?.taX_PAY_DAT) || '---', // 代扣勞務稅付款日
        taxPayBank: data?.taX_BNK_NAM || '---', // 代扣勞務稅付款帳戶
        gen2Amt: formatMoney(data?.geN2_AMT) || '---', // 代扣二代健保金額
        gen2PayDate: formatDate(data?.geN2_PAY_DAT) || '---', // 代扣二代健保付款日
        gen2PayBank: data?.geN2_BNK_NAM || '---', // 代扣二代健保付款帳戶
        realPayAmt: getRealPayAmt(data) || '---', // 實付金額
        realPayWay: getRealPayWay(data) || '---', // 實際付款方式
        realPayDate: formatDate(data?.paY_DAT) || '---', // 實際付款日
        realPayBank: data?.paY_BNK_NAM || '---', // 轉出帳戶
        fillPayInfoUser: getFillPayInfoUser(data) || '---', // 填寫付款明細人
        fillPayInfoDate: getFillPayInfoDate(data) || '---', // 填寫付款明細日期
        confirmPayInfoUser: getConfirmPayInfoUser(data) || '---', // 確認付款人
        confirmPayInfoDate: getConfirmPayInfoDate(data) || '---', // 確認付款日期
        receiptCount: data?.files.length || [], // 檢附單據數量
        payCnyRat: data?.paY_CNYRAT || '---', // 付款當下匯率
        realPayAmtTwd: getRealPayAmtTwd(data) || '---', // 實付金額約當台幣
        foreginPayToCountry: data?.paY_COUNRTY || '---', // 國際匯款-國家
        audit: getAuditsData(data), // 審核流程
    };

    return d;
};
